<template>
  <div>
    <section
      class="text-left mt-0 bg-primar-450"
    >
      <home-slider></home-slider>
    </section>
    <section class=" text-center bg-white">
      <div class="py-10 md:py-20 lg:py-20 2xl:py-24 mx-4 lg:mx-20 xl:mx-40">
        <h3 class="text-black text-center  font-extrabold mb-4">
          <span class="text-primar-400 text-3xl lg:text-4xl xl:text-5xl">{{ $t("homeView.iconsTitle")}}</span><br>
          <span class="text-primar-450 text-2xl lg:text-3xl xl:text-4xl font-paragraph">{{ $t("homeView.iconsTitleTwo")}}</span>
        </h3>
        <div class="leading-7 text-center grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 mt-20">
          <div class="text-center">
            <img class="w-16 lg:w-36 m-auto" src="/images/open-book.gif" />
            <p class="mt-4 w-32 lg:w-56 m-auto text-sm lg:text-base">{{ $t("homeView.iconOne")}}</p>
          </div>
          <div class="text-center">
            <img class="w-16 lg:w-36 m-auto" src="/images/line-chart.gif" />
            <p class="mt-4 w-32 lg:w-56 m-auto text-sm lg:text-base">
              {{ $t("homeView.iconTwo")}}
            </p>
          </div>
          <div class="text-center">
            <img class="w-16 lg:w-36 m-auto" src="/images/stock.gif" />
            <p class="mt-4 w-32 lg:w-56 m-auto text-sm lg:text-base">
              {{ $t("homeView.iconThree")}}
            </p>
          </div>
          <div class="text-center">
            <img class="w-16 lg:w-36 m-auto" src="/images/24-hours-support.gif" />
            <p class="mt-4 w-32 lg:w-56 m-auto text-sm lg:text-base">{{ $t("homeView.iconFour")}}</p>
          </div>
          <div class="text-center">
            <img class="w-16 lg:w-36 m-auto" src="/images/best-customer-experience.gif" />
            <p class="mt-4 w-32 lg:w-56 m-auto text-sm lg:text-base">
              {{ $t("homeView.iconFive")}}
            </p>
          </div>
          <div class="text-center">
            <img class="w-16 lg:w-36 m-auto" src="/images/social-media.gif" />
            <p class="mt-4 w-32 lg:w-56 m-auto text-sm lg:text-base">
              {{ $t("homeView.iconSix")}}
            </p>
          </div>
        </div>
      </div>
      
    </section>
    <section
      class="py-20 lg:py-20 2xl:py-24 bg-primar-650"
    >
      <div class="lg:mx-20 xl:mx-40 text-center">
          <h3
            class="text-white text-shadow md:text-white -mt-10 md:mt-0 text-3xl lg:text-4xl xl:text-5xl font-extrabold mb-8"
            v-html="$t('homeView.simplifiedImmediateExecution')"
          >
          </h3>
          <h3
          class="text-white text-lg md:text-lg lg:text-lg font-light"
          v-html="$t('homeView.simplifiedImmediateExecutionText')"
        ></h3>
        <profit-chart></profit-chart>
        <br/>
        <h3
          class="text-white text-lg md:text-lg lg:text-lg font-light mt-12"
          v-html="$t('homeView.simplifiedImmediateExecutionTextTwo')"
        ></h3>
        <a
          href="https://my.eronto.io/register"
          class="inline-block font-medium text-white bg-gradient-to-r from-primar-550 to-primar-400 hover:to-primar-400 text-base xl:text-base py-2 px-8 mt-6 rounded-md shadow focus:ring-offset-blue-200  cursor-pointer ml-6"
        >
          {{ $t("homeView.joinNow")}}
        </a>
      </div>
          
    </section>
    <section
      class="py-10 md:py-20 lg:py-20 2xl:py-24 bg-primar-600"
    >
      <div class="pt-10 lg:pt-0 lg:mx-20 xl:mx-40 text-center">
          <h3
            class="text-white text-shadow md:text-white -mt-10 md:mt-0 text-3xl lg:text-4xl xl:text-5xl font-extrabold mb-8"
            v-html="$t('homeView.sleepTitle')"
          >
          </h3>
          <h3
            class="text-white text-lg md:text-lg lg:text-lg font-light inline-block"
            v-html="$t('homeView.sleepSub')"
          ></h3>
          
          
          <br><br/>
          <trading-view-ticker></trading-view-ticker>
          <br/>
          <a
            href="https://my.eronto.io/register"
            class="inline-block font-medium text-white bg-gradient-to-r from-primar-550 to-primar-400 hover:to-primar-400 text-base xl:text-base py-2 px-8 mt-6 rounded-md shadow focus:ring-offset-blue-200  cursor-pointer ml-6"
          >
            {{ $t("homeView.joinNow")}}
          </a>
      </div>
          
    </section>
    <section

      class="py-0 md:py-14 mx-4 lg:mx-20 xl:mx-40 "
    >
      <div  class="-ml-4 -mr-4 lg:-ml-20 lg:-mr-20 xl:-ml-40 xl:-mr-40 relative">
        <div
        id="small-back"
          class="shadow-md mx-4 lg:mx-20 text-center rounded-xl p-6 sm:py-6 sm:px-8 md:p-12 transform translate-y-1/2"
        >
       
            <h3
              class="text-white text-center text-2xl md:text-3xl lg:text-4xl leading-10 font-extrabold"
            >
              {{ $t("homeView.challenge")}}
            </h3>
          
          <a
            href="https://my.eronto.io/register"
            class="cursor-pointer inline-block shadow rounded-md px-10 py-4 mt-6 font-medium text-base text-white bg-gradient-to-r from-primar-550 to-primar-400 hover:to-primar-400 "
          >
            {{ $t("homeView.joinNow")}}
          </a>
        </div>
      </div>
      
    </section>

    <br/><br/><br/><br/><br/>
    <section
      class="px-10 mb-4  py-20"
    >
      <div class="">
          <div class="slide-bar-items">
            <div class="ml-5 md:ml-0 text-center">
              <img
                src="images/visat.svg"
                alt="Visa"
              />
            </div>
            
            <div class="ml-5 md:ml-0 text-center">
              <img
                src="images/mastercard.svg"
                alt="Mastercard"
              />
            </div>
          </div>
      </div>
    </section>
</div>
</template>
<script>
import MarketTable from '../components/MarketTable.vue'
import TradingViewTicker from '../components/TradingViewTicker.vue'
import HomeSlider from '../components/HomeSlider.vue'
import TradingViewTableMobile from '../components/TradingViewTableMobile.vue'
import InfiniteSlideBar from 'vue-infinite-slide-bar'
import UsdtIcon from '../icons/Usdt.vue';
import AdaIcon from '../icons/Ada.vue';
import BchIcon from '../icons/Bch.vue';
import BtcIcon from '../icons/Btc.vue';
import DashIcon from '../icons/Dash.vue';
import EosIcon from '../icons/Eos.vue';
import EthIcon from '../icons/Eth.vue';
import LtcIcon from '../icons/Ltc.vue';
import XmrIcon from '../icons/Xmr.vue';
import XrpIcon from '../icons/Xrp.vue';
import AccountTypes from '../components/AccountTypes.vue';
import ProfitChart from '../components/ProfitChart.vue';

export default {
  components: {
    MarketTable, InfiniteSlideBar, TradingViewTicker, TradingViewTableMobile, UsdtIcon,HomeSlider,
    AdaIcon,
    AccountTypes,
    BchIcon,
    DashIcon,
    BtcIcon,
    EosIcon,
    EthIcon,
    LtcIcon,
    XmrIcon,
    XrpIcon,
    ProfitChart
  },
  data() {
		return {
      loaded: false,
      marginTop: 0,
    }
	},
  
  created() {
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style scoped>
  .laptop {
    height: calc(100% + 50px);
  }

  @media (min-width: 768px) {
    .hero-figure {
      width: calc(50% + 10rem);
    }
  }

  .slide-bar-items {
    display: flex;
    justify-content: space-around;
  }

  #small-back {
    background-image: url('/images/lastback.png');
    background-size: cover;
    background-repeat: no-repeat;
  }
</style>